import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { StatusActions } from '../actions/status.actions';
import { delay, map, tap } from 'rxjs';

@Injectable()
export class StatusEffects {
  showPrintDialog$;

  constructor(private actions$: Actions) {
    this.showPrintDialog$ = createEffect(() => {
      return this.actions$.pipe(
        ofType(StatusActions.showPrintDialog),
        delay(100),
        tap(() => {
          window.print();
        }),
        map(() => StatusActions.printDialogClosed()),
      );
    });
  }
}
